import { unreadonly } from '../../../types/unreadonly';
import type { TableFilterBase } from '../TableFilter';
import { filterOperators } from '../operators';

const routingFilterOperators = unreadonly([
  ...filterOperators.routing,
  ...filterOperators.empty,
  ...filterOperators.regexCaseSensitive,
  ...filterOperators.column,
  ...filterOperators.color,
] as const);

export type RoutingFilterOperator = (typeof routingFilterOperators)[number];

export type RoutingTableFilter = TableFilterBase & {
  type: 'routing';
};

export const createRoutingFilter = (): RoutingTableFilter => ({
  type: 'routing',
  operators: routingFilterOperators,
});
